.formFieldsContainer,
.fieldGroupContainer,
.fieldContainer,
.spaceBetweenContainer {
    display: flex;
}

.spaceBetweenContainer {
    flex-direction: row;
    justify-content: space-between;
    margin: 20px 0px 0px 0px;
}

.submitButton {
    margin-left: auto;
}

.formFieldsContainer {
    flex-direction: column;
    margin-bottom: 0px;
}

.fieldGroupContainer {
    gap: 10px;
}

.fieldContainer {
    flex: 1 1;
    margin-bottom: 20px;
}

.fieldContainer > * {
    width: 100%;
}

.controlDistribution {
    margin-top: 40px;
}

.accordionMargin {
    margin-bottom: 20px;
}

.accordionContainer {
    display: flex;
    align-items: flex-start;
}

.accordionContainer > button {
    display: flex;
    justify-content: flex-start;
}

.accordionCollapse {
    margin: 12px;
}

.accordionHeaderContainer {
    display: flex;
    width: 100%;
    flex-direction: column;
}

.deleteConfirmationList {
    color: var(--hps-blue);
}